"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pick.title': 'Onboarding Pracownika',
    'onboarding.pick.description': 'Komu chcesz powierzyć nowe obowiązki w Twojej Firmie?',
    'onboarding.pick.loading': 'Ładowanie zawodów...',
};
